<template>
  <div class="h-full w-80 bg-white overflow-y-auto border-l border-gray-200 flex flex-col">
    <!-- Header - Minimal as per WhatsApp -->
    <div class="sticky top-0 bg-white border-b border-gray-200 flex items-center p-2">
      <button @click="closeProfile" class="mr-2">
     
        <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">

          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
        
        </svg>

      </button>
      Contact info
    </div>

    <!-- Profile Section - Simplified to match image -->
    <div class="flex flex-col items-center pt-4 pb-3 bg-white">
      <div class="relative">
        <img class="w-20 h-20 rounded-full object-cover" :src="getProfileImage()" alt="Profile" />
        <div v-if="isOnline()" class="absolute top-0 right-0 w-3 h-3 bg-green-500 rounded-full"></div>
      </div>
      <div class="mt-2 text-center">
        <h6 class="text-base font-medium text-gray-800">
          {{ getContactName() }}
        </h6>
        <p class="text-sm text-gray-500">{{ getPhoneNumber() }}</p>
      </div>
    </div>

    <!-- Action Buttons - Simplified to match WhatsApp -->
    <div class="grid grid-cols-4 border-b border-gray-200">
      <div class="flex flex-col items-center py-3">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-600 mb-1" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 5a2 2 0 012-2h3.28a1 1 0 01.948.684l1.498 4.493a1 1 0 01-.502 1.21l-2.257 1.13a11.042 11.042 0 005.516 5.516l1.13-2.257a1 1 0 011.21-.502l4.493 1.498a1 1 0 01.684.949V19a2 2 0 01-2 2h-1C9.716 21 3 14.284 3 6V5z" />
        </svg>
        <span class="text-xs text-gray-600">Call</span>
      </div>
      <div class="flex flex-col items-center py-3">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-600 mb-1" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
        </svg>
        <span class="text-xs text-gray-600">Email</span>
      </div>
      <div class="flex flex-col items-center py-3">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-600 mb-1" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M8 12h.01M12 12h.01M16 12h.01M21 12c0 4.418-4.03 8-9 8a9.863 9.863 0 01-4.255-.949L3 20l1.395-3.72C3.512 15.042 3 13.574 3 12c0-4.418 4.03-8 9-8s9 3.582 9 8z" />
        </svg>
        <span class="text-xs text-gray-600">Chat</span>
      </div>
      <div class="flex flex-col items-center py-3">
        <svg xmlns="http://www.w3.org/2000/svg" class="h-6 w-6 text-gray-600 mb-1" fill="none" viewBox="0 0 24 24"
          stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
            d="M8.684 13.342C8.886 12.938 9 12.482 9 12c0-.482-.114-.938-.316-1.342m0 2.684a3 3 0 110-2.684m0 2.684l6.632 3.316m-6.632-6l6.632-3.316m0 0a3 3 0 105.367-2.684 3 3 0 00-5.367 2.684zm0 9.316a3 3 0 105.368 2.684 3 3 0 00-5.368-2.684z" />
        </svg>
        <span class="text-xs text-gray-600">Share</span>
      </div>
    </div>

    <!-- Contact Details -->
    <div class="flex-1">
      <!-- About Section - Simplified -->
      <div class="px-4 py-3 border-b border-gray-200">
        <h6 class="text-sm font-medium text-gray-800">About</h6>
        <p class="text-sm">Available</p>
      </div>

      <!-- Media Section - Simplified -->
      <div class="px-4 py-3 border-b border-gray-200">
        <div class="flex justify-between items-center">
          <h6 class="text-sm font-medium text-gray-800">Media, links and docs</h6>
          <div class="flex items-center text-gray-500">
            <span class="text-sm mr-1">68</span>
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd"
                d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                clip-rule="evenodd" />
            </svg>
          </div>
        </div>
      </div>

      <!-- Additional Details - Simplified -->
      <div class="px-4 py-2 border-b border-gray-200">
        <div class="flex items-center justify-between py-2">
          <div>
            <h6 class="text-sm font-medium text-gray-800">Email</h6>
            <p class="text-sm text-gray-600">tarun@aruvaa.com</p>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" />
          </svg>
        </div>
        <div class="flex items-center justify-between py-2">
          <div>
            <h6 class="text-sm font-medium text-gray-800">Date Added</h6>
            <p class="text-sm text-gray-600">Dec 9, 2023, 11:42 AM</p>
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 text-gray-500" fill="none" viewBox="0 0 24 24"
            stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </div>
      </div>

      <!-- Actions -->
      <div class="px-4 py-3">
        <button class="flex items-center w-full justify-between text-red-500 py-3">
          <div class="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd" />
            </svg>
            Block contact
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
        <button class="flex items-center w-full justify-between text-red-500 py-3">
          <div class="flex items-center">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5 mr-3" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd"
                d="M8.257 3.099c.765-1.36 2.722-1.36 3.486 0l5.58 9.92c.75 1.334-.213 2.98-1.742 2.98H4.42c-1.53 0-2.493-1.646-1.743-2.98l5.58-9.92zM11 13a1 1 0 11-2 0 1 1 0 012 0zm-1-8a1 1 0 00-1 1v3a1 1 0 002 0V6a1 1 0 00-1-1z"
                clip-rule="evenodd" />
            </svg>
            Report contact
          </div>
          <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>

    <!-- New Contact Modal -->
    <div v-if="isModalVisible" class="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
      <div class="bg-white w-full max-w-md rounded-lg overflow-hidden">
        <div class="bg-teal-600 text-white px-4 py-3 flex items-center">
          <button @click="closeModal" class="mr-3">
            <svg xmlns="http://www.w3.org/2000/svg" class="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
              <path fill-rule="evenodd"
                d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                clip-rule="evenodd" />
            </svg>
          </button>
          <h2 class="text-lg font-medium">Create New Contact</h2>
        </div>
        <form @submit.prevent="saveContact" class="px-4 py-5">
          <div class="mb-4">
            <label class="block text-sm text-gray-700 mb-1">Name</label>
            <input v-model="newContact.name" type="text"
              class="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-teal-500"
              placeholder="Enter name" required />
          </div>
          <div class="mb-4">
            <label class="block text-sm text-gray-700 mb-1">Phone Number</label>
            <input v-model="phoneForSaving" type="text"
              class="w-full p-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-teal-500"
              placeholder="Enter phone number" disabled />
          </div>
          <div class="flex justify-end border-t border-gray-200 pt-4">
            <button type="button" @click="closeModal"
              class="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-100 rounded mr-2">
              Cancel
            </button>
            <button type="submit"
              class="px-4 py-2 text-sm font-medium text-white bg-teal-600 rounded hover:bg-teal-700">
              Save
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    selectedId: String,
    selectedType: String,
    receivedValue: {
      type: [Object, String],
      required: false,
      default: () => ({})
    }
  },

  data() {
    return {
      isModalVisible: false,
      newContact: {
        name: ''
      }
    };
  },

  computed: {
    phoneForSaving() {
      if (typeof this.receivedValue === 'object') {
        return this.receivedValue.participant_2_phone_no ||
          this.receivedValue.wa_phone_number || '';
      }
      return '';
    }
  },

  methods: {
    getProfileImage() {
      return "https://randomuser.me/api/portraits/med/women/32.jpg";
    },

    isOnline() {
      // This would be replaced with actual online status logic
      return true;
    },

    getContactName() {
      if (typeof this.receivedValue === 'object') {
        if (this.receivedValue.name) {
          return this.receivedValue.name;
        } else if (this.receivedValue.participant_2_phone_no || this.receivedValue.wa_phone_number) {
          return this.receivedValue.participant_2_phone_no || this.receivedValue.wa_phone_number;
        }
      }
      return typeof this.receivedValue === 'string' ? this.receivedValue : 'Unknown Contact';
    },

    getPhoneNumber() {
      if (typeof this.receivedValue === 'object') {
        return this.receivedValue.participant_2_phone_no ||
          this.receivedValue.wa_phone_number || 'No phone number';
      }
      return 'No phone number';
    },

    formatDate() {
      // For demonstration, we'll use the prop value or a default
      return 'Dec 9, 2023, 11:42 AM';
    },

    openModal() {
      this.isModalVisible = true;
    },

    closeModal() {
      this.isModalVisible = false;
    },

    saveContact() {
      const contactToSave = {
        name: this.newContact.name,
        phone_no: this.phoneForSaving
      };

      console.log("New contact saved:", contactToSave);

      // API call to save the contact
      // Using axios as in the original code
      axios.post('/all/conversation/storecontacts', contactToSave)
        .then(response => {
          // Handle success
        })
        .catch(error => {
          // Handle error
        });

      this.closeModal();
      this.$emit('contactsaved');
    },

    closeProfile() {
      console.log("Profile closed");
      this.$emit('close-profile');
    }
  }
}
</script>

<style scoped>
/* Fixed height container while allowing scrolling */
.h-full {
  height: 100vh;
}

/* Extra WhatsApp-specific styling */
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  background: transparent;
}

::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.2);
  border-radius: 3px;
}
</style>